import { render, staticRenderFns } from "./Modelmanagement.vue?vue&type=template&id=38315cb8&scoped=true"
import script from "./Modelmanagement.vue?vue&type=script&lang=js"
export * from "./Modelmanagement.vue?vue&type=script&lang=js"
import style0 from "./Modelmanagement.vue?vue&type=style&index=0&id=38315cb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38315cb8",
  null
  
)

export default component.exports